import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class CustomerAccountActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Base/User/UserBrowser")
	}

	render() {
		return (
			<Activity 
				name="customerAccount"
				RenderedComponent={this.RenderedComponent}
				context="isCustomer"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(CustomerAccountActivity)